import Typography from 'design-system/src/Components/Typography/Typography';
import React, {FC, useMemo, useState} from 'react';
import SuspenseAfterRequired from 'design-system/src/library/AfterRequired/SuspenseAfterRequired';
import Dropdown from 'design-system/src/WebComponent/Dropdown/Dropdown';
import {Pressable} from 'react-native-gesture-handler';
import {CustomActivityIndicator} from 'design-system/src/Components/CustomActivityIndicator';
import Icon from 'design-system/src/Components/Icon/Icon';
import {LangSwitcherLanguages} from '../../types/langSwitcherLanguages.type';
import {Theme} from 'design-system/src/Theme/defaultTheme';
import {TFunction} from 'i18next';

const DefaultMenuDrawer = React.lazy(
  () =>
    import(
      '@src/layout/DefaultLayout/DefaultHeader/DefaultMenuDrawer/DefaultMenuDrawer'
    ),
);

export interface SwitchLangDrawerProps {
  isOpen: boolean;
  languages: LangSwitcherLanguages[];
  currentLanguage: string;
  theme: Theme;
  loadingLanguage: string;
  onClose: () => void | Promise<void>;
  handleChooseLanguage: (lang: string) => Promise<void>;
  t: TFunction;
}

const SwitchLangDrawer: FC<SwitchLangDrawerProps> = ({
  isOpen,
  languages,
  currentLanguage,
  theme,
  loadingLanguage,
  onClose,
  handleChooseLanguage,
  t,
}) => {
  const selectedItem = useMemo(() => {
    return languages.find(el => {
      return el.value === currentLanguage;
    }) || languages[0];
  }, [currentLanguage])

  return (
    <SuspenseAfterRequired required={isOpen}>
      <DefaultMenuDrawer
        open={isOpen}
        onClose={onClose}
        leftHeader={
          <Dropdown
            placement="bottomLeft"
            content={
              <>
                {languages.map(langItem => {
                  const isActive = selectedItem?.value === langItem.value;
                  return (
                    <Pressable
                      key={langItem.value}
                      disabled={isActive}
                      onPress={e => handleChooseLanguage(langItem.value)}
                      style={{
                        flexWrap: 'nowrap',
                        flexDirection: 'row',
                        // @ts-ignore
                        gap: 8,
                      }}>
                      <Typography
                        variant="body3"
                        color={
                          (isActive && (() => theme.primary)) || undefined
                        }>
                        {/* i18next-extract-disable-next-line */}
                        {t(langItem.value, '') || langItem.label}
                      </Typography>

                      {loadingLanguage === langItem.value ? (
                        <CustomActivityIndicator />
                      ) : (
                        isActive && <Icon name="check" color={theme.primary} />
                      )}
                    </Pressable>
                  );
                })}
              </>
            }>
            <div
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                display: 'flex',
                cursor: 'pointer',
                gap: 8,
              }}>
              <Typography
                variant="body3"
                style={{
                  height: 'fit-content',
                }}>
                {/* i18next-extract-disable-next-line */}
                {t(currentLanguage, '') || selectedItem?.label}
              </Typography>
              <Icon name={'arrow-down'} size="16" color="white" />
            </div>
          </Dropdown>
        }
      />
    </SuspenseAfterRequired>
  );
};

export default SwitchLangDrawer;
